/*
* parent_type 
*  search : 検索フォーム用バリデーションタイプ
*  regist : 登録・更新フォーム用バリデーションタイプ
*  disp   : 表示フォーマット用バリデーションタイプ
*/


export const parent_type = {
    // capacity_qty_1:{search:[],regist:[],disp:{format:"",unit:""}},
    percent_1: { search: [], regist: ['size'], disp: { format: "", unit: "%" } },
    // months_1:{search:[],regist:[],disp:{format:"",unit:""}},
    // amt_2:{search:[],regist:[],disp:{format:"",unit:""}},
    // flag_1:{search:[],regist:[],disp:{format:"",unit:""}},
    bank_no_1: {
        search: ['length', 'bankNumber'],
        regist: ['length', 'bankNumber'],
        disp: { format: "", unit: "" }
    },

    disp_lat_1: { search: [], regist: [], disp: { format: "", unit: "" } },
    disp_datetime_1: { search: [], regist: [], disp: { format: "format_datetime", unit: "" } },

    disp_other_qty_1: { search: [], regist: [], disp: { format: "", unit: "個" } },
    disp_time_1: { search: [], regist: [], disp: { format: "", unit: "分" } },
    disp_distance_1: { search: [], regist: [], disp: { format: "comma_delimited", unit: "m" } },
    disp_percent_1: { search: [], regist: [], disp: { format: "", unit: "%" } },
    disp_month_1: { search: [], regist: [], disp: { format: "", unit: "ヶ月" } },
    disp_day_1: { search: [], regist: [], disp: { format: "", unit: "日" } },

    disp_user_1: { search: [], regist: [], disp: { format: "", unit: "" } },
    disp_tel_fax_1: { search: [], regist: [], disp: { format: "phone_number", unit: "" } },
    disp_url_1: { search: [], regist: [], disp: { format: "", unit: "" } },
    disp_pdf_image_link_1: { search: [], regist: [], disp: { format: "", unit: "" } },
    disp_alpha_1: { search: [], regist: [], disp: { format: "", unit: "" } },
    disp_img_1: { search: [], regist: [], disp: { format: "", unit: "" } },
    disp_mail_1: { search: [], regist: [], disp: { format: "", unit: "" } },
    disp_zip_1: { search: [], regist: [], disp: { format: "", unit: "" } },
    disp_addr_1: { search: [], regist: [], disp: { format: "", unit: "" } },
    disp_status_1: { search: [], regist: [], disp: { format: "", unit: "" } },
    disp_memo_1: { search: [], regist: [], disp: { format: "", unit: "" } },
    disp_default_1: { search: [], regist: [], disp: { format: "", unit: "" } },

    cst_prefecture: { search: [], regist: [], disp: { format: "cst_prefecture", unit: "" } },
    cst_ab_select: { search: [], regist: [], disp: { format: "cst_ab_select", unit: "" } },
    cst_landmark_available: { search: [], regist: [], disp: { format: "cst_landmark_available", unit: "" } },
    cst_landmark_type: { search: [], regist: [], disp: { format: "cst_landmark_type", unit: "" } },
    cst_parking_type: { search: [], regist: [], disp: { format: "cst_parking_type", unit: "" } },
    cst_parking_parallel_type: { search: [], regist: [], disp: { format: "cst_parking_parallel_type", unit: "" } },
    cst_pay_unit_type_day: { search: [], regist: [], disp: { format: "cst_pay_unit_type_day", unit: "" } },
    cst_pay_unit_type_month: { search: [], regist: [], disp: { format: "cst_pay_unit_type_month", unit: "" } },
    cst_commission_type: { search: [], regist: [], disp: { format: "cst_commission_type", unit: "" } },
    cst_payment_type: { search: [], regist: [], disp: { format: "cst_payment_type", unit: "" } },
    cst_tax_in_flag: { search: [], regist: [], disp: { format: "cst_tax_in_flag", unit: "" } },
    cst_non_taxable_flag: { search: [], regist: [], disp: { format: "cst_non_taxable_flag", unit: "" } },
    cst_transshipment_flag: { search: [], regist: [], disp: { format: "cst_transshipment_flag", unit: "" } },
    cst_oneday_flag: { search: [], regist: [], disp: { format: "cst_oneday_flag", unit: "" } },
    cst_request_parking_status: { search: [], regist: [], disp: { format: "cst_request_parking_status", unit: "" } },
    landmark_branch: { search: [], regist: [], disp: { format: "landmark_branch", unit: "" } },
    cst_fraction_amt_flag: { search: [], regist: [], disp: { format: "cst_fraction_amt_flag", unit: "" } },
    cst_discount_rate: { search: [], regist: [], disp: { format: "cst_discount_rate", unit: "" } },
    cst_reminder_sms_flag: { search: [], regist: [], disp: { format: "cst_reminder_sms_flag", unit: "" } },
    cst_notification_flag: { search: [], regist: [], disp: { format: "cst_notification_flag", unit: "" } },
    cst_request_type: { search: [], regist: [], disp: { format: "cst_request_type", unit: "" } },
    cst_want_priority: { search: [], regist: [], disp: { format: "cst_want_priority", unit: "" } },
    cst_want_guide_type: { search: [], regist: [], disp: { format: "cst_want_guide_type", unit: "" } },
    cst_survey_status: { search: [], regist: [], disp: { format: "cst_survey_status", unit: "" } },
    cst_estimate_status: { search: [], regist: [], disp: { format: "cst_estimate_status", unit: "" } },
    cst_payment_status: { search: [], regist: [], disp: { format: "cst_payment_status", unit: "" } },
    cst_capacity_flag: { search: [], regist: [], disp: { format: "cst_capacity_flag", unit: "" } },
    cst_deposit_status: { search: [], regist: [], disp: { format: "cst_deposit_status", unit: "" } },
    cst_due_day_rule: { search: [], regist: [], disp: { format: "cst_due_day_rule", unit: "" } },
    cst_estimate_rule: { search: [], regist: [], disp: { format: "cst_estimate_rule", unit: "" } },
    cst_survey_estimate_rule: { search: [], regist: [], disp: { format: "cst_survey_estimate_rule", unit: "" } },
    cst_estimate_type: { search: [], regist: [], disp: { format: "cst_estimate_type", unit: "" } },
    cst_invoice_process_status: { search: [], regist: [], disp: { format: "cst_invoice_process_status", unit: "" } },
    cst_invoice_create_flag: { search: [], regist: [], disp: { format: "cst_invoice_create_flag", unit: "" } },
    cst_invoice_list_create_flag: { search: [], regist: [], disp: { format: "cst_invoice_list_create_flag", unit: "" } },
    cst_invoice_list_create_type: { search: [], regist: [], disp: { format: "cst_invoice_list_create_type", unit: "" } }, // 2021-11-24 feature/1041
    cst_invoice_type: { search: [], regist: [], disp: { format: "cst_invoice_type", unit: "" } },
    cst_is_active: { search: [], regist: [], disp: { format: "cst_is_active", unit: "" } },
    cst_is_staff: { search: [], regist: [], disp: { format: "cst_is_staff", unit: "" } },
    cst_is_superuser: { search: [], regist: [], disp: { format: "cst_is_superuser", unit: "" } },
    cst_migration_type: { search: [], regist: [], disp: { format: "cst_migration_type", unit: "" } },
    cst_payment_request_status: { search: [], regist: [], disp: { format: "cst_payment_request_status", unit: "" } },
    cst_purchase_order_send_flag: { search: [], regist: [], disp: { format: "cst_purchase_order_send_flag", unit: "" } },
    cst_request_other_status: { search: [], regist: [], disp: { format: "cst_request_other_status", unit: "" } },
    cst_route_map_parking_flag: { search: [], regist: [], disp: { format: "cst_route_map_parking_flag", unit: "" } },
    cst_supplier_type: { search: [], regist: [], disp: { format: "cst_supplier_type", unit: "" } },
    cst_survey_fraction_amt_flag: { search: [], regist: [], disp: { format: "cst_survey_fraction_amt_flag", unit: "" } },
    cst_send_destination_type: { search: [], regist: [], disp: { format: "cst_send_destination_type", unit: "" } },
    cst_resurvey_flag: { search: [], regist: [], disp: { format: "cst_resurvey_flag", unit: "" } },
    cst_contract_create_flag: { search: [], regist: [], disp: { format: "cst_contract_create_flag", unit: "" } },
    cst_payment_due_day_rule: { search: [], regist: [], disp: { format: "cst_payment_due_day_rule", unit: "" } },
    cst_payment_bank_account_type: { search: [], regist: [], disp: { format: "cst_payment_bank_account_type", unit: "" } },
    cst_construction_number_require_flag: { search: [], regist: [], disp: { format: "cst_construction_number_require_flag", unit: "" } },
    cst_payment_due_rule_day: { search: [], regist: [], disp: { format: "cst_payment_due_rule_day", unit: "" } },
    cst_invoice_customer_user_setting: { search: [], regist: [], disp: { format: "cst_invoice_customer_user_setting", unit: "" } },
    cst_customer_branch_noname_flag: { search: [], regist: [], disp: { format: "cst_customer_branch_noname_flag", unit: "" } },
    cst_information_display_header: { search: [], regist: [], disp: { format: "cst_information_display_header", unit: "" } },
    cst_information_display_advertisement: { search: [], regist: [], disp: { format: "cst_information_display_advertisement", unit: "" } },
    cst_information_status: { search: [], regist: [], disp: { format: "cst_information_status", unit: "" } },
    cst_information_data_type: { search: [], regist: [], disp: { format: "cst_information_data_type", unit: "" } },
    cst_cu_customer_option_approval: { search: [], regist: [], disp: { format: "cst_cu_customer_option_approval", unit: "" } },
    cst_cu_customer_option_approval_step: { search: [], regist: [], disp: { format: "cst_cu_customer_option_approval_step", unit: "" } },
    cst_cu_customer_option_data_scope: { search: [], regist: [], disp: { format: "cst_cu_customer_option_data_scope", unit: "" } },
    cst_delete_flag: { search: [], regist: [], disp: { format: "cst_delete_flag", unit: "" } },
    cst_banned_flag: { search: [], regist: [], disp: { format: "cst_banned_flag", unit: "" } },
    cst_customer_branch_reminder_send_flag: { search: [], regist: [], disp: { format: "cst_customer_branch_reminder_send_flag", unit: "" } },
    cst_customer_user_reminder_send_flag: { search: [], regist: [], disp: { format: "cst_customer_user_reminder_send_flag", unit: "" } },
    cst_information_not_login: { search: [], regist: [], disp: { format: "cst_information_not_login", unit: "" } },
    cst_customer_agreement_status: { search: [], regist: [], disp: { format: "cst_customer_agreement_status", unit: "" } },
    cst_auto_approval_flag: { search: [], regist: [], disp: { format: "cst_auto_approval_flag", unit: "" } },
    text_long_1: {
        search: ['length'],
        regist: ['length'],
        disp: {}
    },
    text_long_2: {
        search: ['length'],
        regist: ['length'],
        disp: {}
    },
    text_long_3: {
        search: ['length'],
        regist: ['length'],
        disp: {}
    },
    text_long_4: {
        search: ['length'],
        regist: ['length'],
        disp: {}
    },
    text_80: {
        search: ['length'],
        regist: ['length', 'alphanumericWithUnderscore'],
        disp: {}
    },
    text_ja_255: {
        search: ['length'],
        regist: ['length'],
        disp: {}
    },
    text_ja_245: {
        search: ['length'],
        regist: ['length'],
        disp: {}
    },
    text_ja_20000: {
        search: ['length'],
        regist: ['length'],
        disp: {}
    },
    text_ja_60: {
        search: ['length'],
        regist: ['length'],
        disp: {}
    },
    text_ja_2: {
        search: ['length'],
        regist: ['length', 'fullWidthKana'],
        disp: {}
    },
    text_ja_3: {
        search: ['length'],
        regist: ['autoHalfWidthKana', 'length', 'halfWidthKana'],
        disp: {}
    },
    tel_fax_1: {
        search: [],
        regist: ['lengthWithHyphenRemove', 'numberOnly'],
        disp: {}
    },
    tel_fax_2: {
        search: [],
        regist: ['lengthWithHyphenRemove', 'numberOnly'],
        disp: {}
    },
    tel_fax_3: {
        search: [],
        regist: ['multiPhoneNumber'],
        disp: {}
    },
    // 固定電話専用
    tel_fax_4: {
        search: [],
        regist: ['lengthWithHyphenRemove', 'numberOnly'],
        disp: {}
    },
    zip_1: {
        search: [],
        regist: ['postalCode'],
        disp: {}
    },
    amt_1: {
        search: ['size'], regist: ['size'], disp: { format: "comma_delimited", unit: "円" }
    },
    amt_2: {
        search: ['size'], regist: ['size'], disp: { format: "comma_delimited", unit: "円" }
    },
    amt_3: {
        search: ['size'], regist: ['size'], disp: { format: "comma_delimited", unit: "円" }
    },
    mail_1: {
        search: ['length'],
        regist: ['length', 'alphanumericWithEmail'],
        disp: {}
    },
    num_1: {
        search: ['size'], regist: ['size'], disp: { format: "comma_delimited", unit: "台" },
    },
    distance_1: {
        search: ['size'], regist: ['size'], disp: { format: "", unit: "" }
    },
    time_1: {
        search: ['size'], regist: ['size'], disp: { format: "", unit: "" }
    },
    date_1: {
        search: [], regist: ['dateMinMax'], disp: { format: "format_date", unit: "" }
    },
    date_2: {
        search: [], regist: ['dateMinMax'], disp: { format: "format_date", unit: "" }
    },
    moeny_yen_1: {
        search: ['dateMinMax'], regist: [], disp: { format: "", unit: "円" }
    },
    id_1: {
        search: ['length'], regist: ["length"], disp: {}
    },
    id_2: {
        search: [], regist: ["lengthWithalphanumeric"], disp: { format: "format_hankaku_lower" }
    },

    capacity_qty_1: {
        search: ['size'], regist: ["size"], disp: { format: "", unit: "台" }
    },
    limit_max_distance: {
        search: ['limit_max_distance'], regist: [], disp: {}
    },
    dueday_1: {
        search: ['size'], regist: ['size'], disp: {},
    },
    month_1: {
        search: ['size'], regist: ['size'], disp: { format: "", unit: "ヶ月後" },
    },
    natural_id: {
        search: ['length'], regist: ["length", "alphanumeric"], disp: {}
    },
    text_long_without_doublequote: {
        search: ['length'],
        // #1701
        regist: ['length', 'withoutDoubleQuote'],
        disp: {}
    },
    cst_auto_order_display_flag: { search: [], regist: [], disp: { format: "cst_auto_order_display_flag", unit: "" } },
    cst_auto_order_function_flag: { search: [], regist: [], disp: { format: "cst_auto_order_function_flag", unit: "" } },
    cst_auto_order_execution_flag: { search: [], regist: [], disp: { format: "cst_auto_order_execution_flag", unit: "" } },
    cst_dandori_work_use_flag: { search: [], regist: [], disp: { format: "cst_dandori_work_use_flag", unit: "" } },
    dandori_work_place_code: {
        search: ['length'], regist: ["length"], disp: {}
    },
    dandori_work_access_token: {
        search: ['length'], regist: ["length"], disp: {}
    },
    cst_ex_genba_plus_use_flag:{search:[],regist:[],disp:{format:"cst_ex_genba_plus_use_flag",unit:""}},
    cst_ex_andpad_use_flag:{search:[],regist:[],disp:{format:"cst_ex_andpad_use_flag",unit:""}},
    cst_ex_andpad_quote_file_flag:{search:[],regist:[],disp:{format:"cst_ex_andpad_quote_file_flag",unit:""}},
    cst_road_usage_permission_use_flag:{search:[],regist:[],disp:{format:"cst_road_usage_permission_use_flag",unit:""}},
};

export const type = {
    PROJECT__site_prefecture: "cst_prefecture",
    ESTIMATE__site_prefecture: "cst_prefecture",
    PARKING__parking_prefecture: "cst_prefecture",
    SUPPLIER__supplier_prefecture: "cst_prefecture",
    USER_BRANCH__user_branch_prefecture: "cst_prefecture",
    ESTIMATE__survey_parking_prefecture: "cst_prefecture",
    CUSTOMER_BRANCH__customer_branch_prefecture: "cst_prefecture",
    CUSTOMER_BRANCH__customer_branch_invoice_prefecture: "cst_prefecture",
    INVOICE__invoice_customer_branch_prefecture: "cst_prefecture",
    PARKING__capacity_flag_car: "cst_capacity_flag",
    PARKING__capacity_flag_light_truck: "cst_capacity_flag",
    PARKING__capacity_flag_other: "cst_capacity_flag",
    PARKING__capacity_flag_truck: "cst_capacity_flag",
    ESTIMATE__survey_capacity_flag_car: "cst_capacity_flag",
    ESTIMATE__survey_capacity_flag_light_truck: "cst_capacity_flag",
    ESTIMATE__survey_capacity_flag_other: "cst_capacity_flag",
    ESTIMATE__survey_capacity_flag_truck: "cst_capacity_flag",
    PARKING__commission_type: "cst_commission_type",
    CUSTOMER_USER__customer_reminder_sms_flag: "cst_reminder_sms_flag",
    CUSTOMER_USER__notification_flag: "cst_notification_flag",
    INVOICE__deposit_status: "cst_deposit_status",
    CUSTOMER_BRANCH__due_day_rule: "cst_due_day_rule",
    CUSTOMER_BRANCH__estimate_rule: "cst_estimate_rule",
    ESTIMATE__survey_estimate_rule: "cst_survey_estimate_rule",
    ESTIMATE__estimate_status: "cst_estimate_status",
    ESTIMATE_DETAIL__estimate_type: "cst_estimate_type",
    CUSTOMER_BRANCH__fraction_amt_flag: "cst_fraction_amt_flag",
    INVOICE__invoice_process_status: "cst_invoice_process_status",
    INVOICE__invoice_create_flag: "cst_invoice_create_flag",
    INVOICE__invoice_type: "cst_invoice_type",
    USER__is_active: "cst_is_active",
    USER__is_staff: "cst_is_staff",
    USER__is_superuser: "cst_is_superuser",
    PARKING__landmark_available: "cst_landmark_available",
    PARKING__landmark_type: "cst_landmark_type",
    PARKING__migration_type: "cst_migration_type",
    PARKING__oneday_flag: "cst_oneday_flag",
    PARKING__parking_parallel_type: "cst_parking_parallel_type",
    PARKING__parking_type: "cst_parking_type",
    PARKING__pay_unit_type_day: "cst_pay_unit_type_day",
    PARKING__pay_unit_type_month: "cst_pay_unit_type_month",
    ESTIMATE__payment_request_status: "cst_payment_request_status",
    PAYMENT__payment_status: "cst_payment_status",
    PAYMENT__payment_type: "cst_payment_type",
    INVOICE__purchase_order_send_flag: "cst_purchase_order_send_flag",
    REQUEST__request_other_status: "cst_request_other_status",
    REQUEST_PARKING__request_parking_status: "cst_request_parking_status",
    REQUEST__request_type: "cst_request_type",
    REQUEST_PARKING__route_map_parking_flag: "cst_route_map_parking_flag",
    SUPPLIER__supplier_type: "cst_supplier_type",
    ESTIMATE__survey_fraction_amt: "cst_fraction_amt_flag",
    ESTIMATE__survey_parking_parallel_type: "cst_parking_parallel_type",
    ESTIMATE__survey_pay_unit_type_day: "cst_pay_unit_type_day",
    ESTIMATE__survey_pay_unit_type_month: "cst_pay_unit_type_month",
    REQUEST__survey_status: "cst_survey_status",
    ESTIMATE__survey_tax_in_flag: "cst_tax_in_flag",
    ESTIMATE__non_taxable_flag: "cst_non_taxable_flag",
    ESTIMATE__survey_fraction_amt_flag: "cst_fraction_amt_flag",
    CUSTOMER_BRANCH__tax_in_flag: "cst_tax_in_flag",
    PARKING__transshipment_flag: "cst_transshipment_flag",
    REQUEST__want_guide_type: "cst_want_guide_type",
    REQUEST__want_guide_type_subcontract: "cst_want_guide_type",
    REQUEST__want_priority: "cst_want_priority",
    CUSTOMER_BRANCH__discount_rate: "disp_percent_1",
    // ESTIMATE__survey_commission_discount_rate:"disp_percent_1",
    PROJECT__send_destination_type: "cst_send_destination_type",
    REQUEST__resurvey_flag: "cst_resurvey_flag",
    CUSTOMER_BRANCH__invoice_bank_account_type: "cst_payment_bank_account_type",

    CUSTOMER__system_memo: 'text_long_1',
    CUSTOMER__customer_name: 'text_ja_255',
    CUSTOMER__customer_name_kana: 'text_ja_2',
    CUSTOMER__construction_number_require_flag: 'cst_construction_number_require_flag',
    CU_CUSTOMER_OPTION__approval: 'cst_cu_customer_option_approval',
    CU_CUSTOMER_OPTION__approval_step: 'cst_cu_customer_option_approval_step',
    CU_CUSTOMER_OPTION__data_scope: 'cst_cu_customer_option_data_scope',
    CUSTOMER__delete_flag: 'cst_delete_flag',
    CUSTOMER__customer_system_start_date: 'date_1',
    CUSTOMER__customer_system_end_date: 'date_1',
    CUSTOMER_BRANCH__customer_system_start_date: 'date_1',
    CUSTOMER_BRANCH__customer_system_end_date: 'date_1',

    CUSTOMER__customer_natural_id_new: 'natural_id',
    CUSTOMER_BRANCH__customer_branch_natural_id_new: 'natural_id',

    CUSTOMER_BRANCH__system_memo: 'text_long_1',
    CUSTOMER__customer_agreement_status: 'cst_customer_agreement_status',
    // CUSTOMER_BRANCH__customer_branch_name_kana:'text_ja_2',
    CUSTOMER_BRANCH__customer_branch_tel: 'tel_fax_1',
    CUSTOMER_BRANCH__customer_branch_fax: 'tel_fax_1',
    CUSTOMER_BRANCH__customer_branch_zip_code: 'zip_1',
    CUSTOMER_BRANCH__customer_branch_city: 'text_ja_255',
    CUSTOMER_BRANCH__customer_branch_address: 'text_ja_255',
    CUSTOMER_BRANCH__customer_branch_invoice_zip_code: 'zip_1',
    CUSTOMER_BRANCH__customer_branch_invoice_city: 'text_ja_255',
    CUSTOMER_BRANCH__customer_branch_invoice_address: 'text_ja_255',
    CUSTOMER_BRANCH__additional_amt: 'amt_1',
    CUSTOMER_BRANCH__discount_amt: 'amt_3',
    CUSTOMER_BRANCH__invoice_memo: 'text_long_1',
    CUSTOMER_BRANCH__basic_contract_signing_date: 'date_1',
    CUSTOMER_BRANCH__contractor_name: 'text_ja_255',
    CUSTOMER_BRANCH__upper_limit_additional_amt: 'amt_1',
    CUSTOMER_BRANCH__customer_branch_cc_email: 'mail_1',
    CUSTOMER_BRANCH__customer_branch_cc_email_quote: 'mail_1',
    CUSTOMER_BRANCH__invoice_create_flag: 'cst_invoice_create_flag',
    CUSTOMER_BRANCH__invoice_list_create_flag: 'cst_invoice_list_create_flag',
    CUSTOMER_BRANCH__invoice_list_create_type: 'cst_invoice_list_create_type', // 2021-11-24 feature/1041
    CUSTOMER_BRANCH__contract_create_flag: 'cst_contract_create_flag',
    CUSTOMER_BRANCH__payment_due_day_rule: 'cst_payment_due_day_rule',
    CUSTOMER_BRANCH__invoice_bank_account_kana: 'text_ja_3',
    CUSTOMER_BRANCH__invoice_bank_account_number: 'bank_no_1',
    CUSTOMER_BRANCH__customer_branch_name: 'text_ja_255',
    CUSTOMER_BRANCH__customer_branch_name_kana: 'text_ja_2',
    CUSTOMER_BRANCH__payment_due_rule_day: 'cst_payment_due_rule_day',
    CUSTOMER_BRANCH__invoice_customer_user_setting: 'cst_invoice_customer_user_setting',
    CUSTOMER_BRANCH__customer_branch_noname_flag: 'cst_customer_branch_noname_flag',
    CUSTOMER_BRANCH__delete_flag: 'cst_delete_flag',
    CUSTOMER_BRANCH__customer_branch_reminder_send_flag: 'cst_customer_branch_reminder_send_flag',
    CUSTOMER_BRANCH__auto_approval_flag: 'cst_auto_approval_flag',

    CUSTOMER_USER__system_memo: 'text_long_1',
    CUSTOMER_USER__customer_user_name: 'text_ja_255',
    // CUSTOMER_USER__customer_user_name_kana:'text_ja_2',
    CUSTOMER_USER__customer_user_division_name: 'text_ja_255',
    CUSTOMER_USER__customer_user_tel: 'tel_fax_2',
    CUSTOMER_USER__customer_user_tel2: 'tel_fax_1',
    CUSTOMER_USER__customer_user_email: 'mail_1',
    CUSTOMER_USER__customer_user_name_kana: 'text_ja_2',
    CUSTOMER_USER__delete_flag: 'cst_delete_flag',
    CUSTOMER_USER__customer_user_reminder_send_flag: 'cst_customer_user_reminder_send_flag',

    // construction - regist
    PROJECT__construction_number: 'id_1',
    PROJECT__site_customer_user_tel: 'tel_fax_1',
    PROJECT__site_customer_user_name: 'text_ja_255',
    PROJECT__site_name: 'text_ja_255',
    PROJECT__site_name_kana: 'text_ja_2',
    PROJECT__site_city: 'text_ja_255',
    PROJECT__site_address: 'text_ja_255',
    PROJECT__project_start_date: 'date_1',
    PROJECT__project_finish_date: 'date_1',

    // construction - detail
    ESTIMATE__project_tree_memo: 'text_long_1',

    // order - regist / other
    REQUEST__request_date: "date_1",
    REQUEST__car_qty: 'capacity_qty_1',
    REQUEST__light_truck_qty: 'capacity_qty_1',
    REQUEST__truck_qty: 'capacity_qty_1',
    REQUEST__other_car_qty: 'capacity_qty_1',
    REQUEST__other_car_detail: 'text_long_2',
    REQUEST__customer_other_request: 'text_long_2',
    REQUEST__cc_email: 'mail_1',
    REQUEST__estimate_deadline: 'date_2',
    REQUEST__want_start_date: 'date_1',
    REQUEST__want_end_date: 'date_1',
    REQUEST__request_other_deadline: "date_2",
    REQUEST__request_other_start_date: "date_1",
    REQUEST__request_other_end_date: "date_1",
    REQUEST__request_other_qty: "num_1",
    REQUEST_PARKING__site_distance_meter: "disp_distance_1",
    REQUEST_PARKING__site_distance_minute: "disp_time_1",


    // bingMapEx
    // PARKING__parking_name:
    SUPPLIER__supplier_tel: 'tel_fax_1',
    SUPPLIER__supplier_zip_code: 'zip_1',
    REQUEST_PARKING__request_parking_space_qty: 'capacity_qty_1',
    REQUEST_PARKING__contact_memo: 'text_ja_20000',

    // estimate - regist
    REQUEST__survey_report: 'text_long_1',
    ESTIMATE__survey_parking_name: 'text_ja_255',
    ESTIMATE__survey_parking_city: 'text_ja_255',
    ESTIMATE__survey_parking_address: 'text_ja_255',
    ESTIMATE__survey_parking_address_contract: 'text_ja_255',
    ESTIMATE__survey_capacity_type_other: 'text_ja_255',
    ESTIMATE__survey_capacity_special_request: 'text_long_1',
    ESTIMATE__supplier_name: 'text_ja_255',
    ESTIMATE__supplier_name_kana: 'text_ja_2',
    ESTIMATE__supplier_user_name: 'text_ja_255',
    ESTIMATE__supplier_tel: 'tel_fax_1',
    ESTIMATE__supplier_tel2: 'tel_fax_1',
    ESTIMATE__supplier_fax: 'tel_fax_1',
    ESTIMATE__survey_capacity_qty: 'capacity_qty_1',
    // ESTIMATE__survey_site_distance_minute:
    ESTIMATE__survey_site_distance_meter: 'distance_1',
    ESTIMATE__survey_cost_commission: 'amt_1',
    ESTIMATE__survey_cost_other: 'amt_1',
    ESTIMATE__survey_cost_security_deposit: 'amt_1',
    ESTIMATE__survey_cost_key_money: 'amt_1',
    ESTIMATE__survey_cost_total_amt: 'amt_1',
    ESTIMATE__survey_cost_security_deposit_total_amt: 'amt_1',
    ESTIMATE__survey_commission_discount_amt: 'amt_1',
    ESTIMATE__survey_tax_amt: 'amt_1',
    ESTIMATE__survey_parking_rent_profit: 'amt_1',
    ESTIMATE__quote_tax_amt: 'amt_1',
    ESTIMATE__survey_month_qty: 'disp_month_1',
    ESTIMATE__survey_day_qty: 'disp_day_1',
    ESTIMATE__quote_month_qty: 'disp_month_1',
    ESTIMATE__quote_day_qty: 'disp_day_1',

    ESTIMATE__survey_parking_rent: 'amt_1',
    ESTIMATE__survey_commission: 'amt_1',
    ESTIMATE__survey_commission_discount_rate: "percent_1",
    ESTIMATE__survey_key_money: 'amt_1',
    ESTIMATE__survey_subtotal_amt: 'amt_1',
    // ESTIMATE__survey_tax_in_flag:
    // ESTIMATE__survey_fraction_amt_flag:
    ESTIMATE__survey_total_amt: 'amt_1',
    ESTIMATE__survey_available_start_date: 'date_1',
    ESTIMATE__survey_available_end_date: 'date_1',
    ESTIMATE__survey_discount_amt: 'amt_3',
    ESTIMATE__survey_cost_parking_rent: 'amt_1',
    ESTIMATE__add_cost_amt: 'amt_2',
    ESTIMATE__add_cost_security_deposit_amt: 'amt_2',
    TEMP__cost_total_amt: 'amt_1',
    ESTIMATE__estimate_expire_date: 'date_2',

    // requestpayment - list
    ESTIMATE__quote_cost_adjustment: 'amt_2',
    INVOICE__invoice_amt: 'amt_1',
    ESTIMATE__quote_cost_security_deposit_total_amt: 'amt_1',

    // requestpayment - regist / other
    // PAYMENT__payment_bank: 
    // PAYMENT__payment_bank_branch: 'text_ja_255', // select
    // PAYMENT__payment_bank_account_kana: 'text_ja_255',
    // PAYMENT__payment_bank_account_type: 'text_ja_255',
    // PAYMENT__payment_bank_account_number: 'text_ja_255',
    // PAYMENT__payment_type: 'flag_1' // radio

    PAYMENT__payment_bank_account_kana: 'text_ja_3',
    PAYMENT__payment_bank_account_number: 'bank_no_1',
    PAYMENT__payment_amt: 'amt_1',
    PAYMENT__payment_user_memo: 'text_long_without_doublequote',
    PAYMENT__add_cost_amt: 'amt_2',
    PAYMENT__add_cost_security_deposit_amt: 'amt_2',
    ESTIMATE__add_cost_memo: 'text_long_1',
    PAYMENT__bank_natural_id: 'text_ja_255',
    PAYMENT__bank_branch_natural_id: 'text_ja_255',

    // payment - list
    ESTIMATE__payment_return_memo: 'text_long_1',
    PAYMENT__payment_finish_date: 'date_1',

    // SUPPLIER - regist
    SUPPLIER__system_memo: 'text_long_1',
    SUPPLIER__supplier_name: 'text_ja_255',
    SUPPLIER__supplier_name_kana: 'text_ja_2',
    SUPPLIER__supplier_fax: 'tel_fax_1',
    SUPPLIER__supplier_city: 'text_ja_255',
    SUPPLIER__supplier_address: 'text_ja_255',
    SUPPLIER__supplier_tel2: 'tel_fax_1',
    SUPPLIER__supplier_zip_code: 'zip_1',
    SUPPLIER__supplier_email: 'mail_1',
    SUPPLIER__delete_flag: 'cst_delete_flag',
    SUPPLIER__banned_flag: 'cst_banned_flag',

    // SUPPLIER_BANK - regist
    SUPPLIER_BANK__supplier_bank_account_kana: 'text_ja_3',
    SUPPLIER_BANK__supplier_bank_account_number: 'bank_no_1',

    // PARKING -regist
    PARKING__system_memo: 'text_long_1',
    PARKING__parking_name: 'text_ja_245',
    PARKING__parking_name_kana: 'text_ja_2',
    PARKING__parking_name_kana: 'text_ja_2',
    PARKING__parking_name_contract: 'text_ja_255',
    PARKING__parking_city: 'text_ja_255',
    PARKING__parking_address: 'text_ja_255',
    PARKING__parking_address_contract: 'text_ja_255',
    PARKING__capacity_car_type: 'text_ja_255',
    PARKING__capacity_special_request: 'text_long_1',
    PARKING__special_note: 'text_long_1',
    PARKING__cost_parking_rent: 'amt_1',
    PARKING__cost_commission: 'amt_1',
    PARKING__cost_security_deposit: 'amt_1',
    PARKING__cost_key_money: 'amt_1',
    PARKING__delete_flag: 'cst_delete_flag',
    PARKING__banned_flag: 'cst_banned_flag',

    // estimatelist
    ESTIMATE__order_memo: 'text_long_1',
    ESTIMATE__quote_capacity_qty: 'capacity_qty_1',
    ESTIMATE__quote_plotting_number: 'text_ja_255',
    ESTIMATE__quote_available_end_date: 'date_1',
    ESTIMATE__quote_available_start_date: 'date_1',
    ESTIMATE__survey_adjustment_amt: 'amt_2',

    ESTIMATE__quote_cost_total_amt: 'amt_1',
    ESTIMATE__quote_subtotal_amt: 'amt_1',
    ESTIMATE__quote_total_amt: 'amt_1',

    ESTIMATE__change_invoice_name: 'text_ja_255',

    ESTIMATE__order_capacity_qty: 'capacity_qty_1',
    ESTIMATE__order_start_date: 'date_1',
    ESTIMATE__order_end_date: 'date_1',
    ESTIMATE__order_schedule_date: 'date_1',

    ESTIMATE__return_deadline: 'date_1',
    ESTIMATE__refund_amt: 'amt_1',

    // list - search
    PROJECT__project_natural_id: 'text_ja_255',
    USER__name: 'text_ja_255',
    REQUEST__request_natural_id: 'text_ja_255',
    // REQUEST__onsite_survey_account: 'text_ja_255',
    INVOICE__estimate_natural_id: 'text_ja_255',
    INVOICE__invoice_user_memo: 'text_long_without_doublequote',
    INVOICE__invoice_customer_branch_name: 'text_ja_255',
    INVOICE__invoice_closing_date: 'date_1',
    INVOICE__invoice_note: 'text_long_without_doublequote',

    CUSTOMER_BRANCH__customer_branch_invoice_zip_code: 'zip_1',
    CUSTOMER_BRANCH__customer_branch_invoice_city: 'text_ja_255',
    CUSTOMER_BRANCH__customer_branch_invoice_address: 'text_ja_255',
    CUSTOMER_BRANCH__invoice_bank_name: 'text_ja_255',
    CUSTOMER_BRANCH__invoice_bank_branch_name: 'text_ja_255',
    CUSTOMER_BRANCH__invoice_bank_account_kana: 'text_ja_3',
    CUSTOMER_BRANCH__invoice_bank_account_number: 'bank_no_1',
    CUSTOMER_BRANCH__discount_rate: 'percent_1',
    CUSTOMER_BRANCH__payment_due_rule_month: 'month_1',
    CUSTOMER_BRANCH__due_day_rule_day: 'dueday_1',

    NODB__fax_recipient_name: 'text_ja_255',
    NODB__fax_recipient_number: 'tel_fax_1',
    NODB__user_memo: 'text_long_1',

    SECURITY_DEPOSIT__security_deposit_memo: 'text_long_1',
    SECURITY_DEPOSIT__security_deposit_prepare_contact_date: 'date_1',
    SECURITY_DEPOSIT__security_deposit_contact_date: 'date_1',
    SECURITY_DEPOSIT__security_deposit_collect_finish_date: 'date_1',
    SECURITY_DEPOSIT_DETAIL__security_deposit_collect_date: 'date_1',
    SECURITY_DEPOSIT_DETAIL__security_deposit_collect_amt: 'amt_2',
    SECURITY_DEPOSIT_DETAIL__security_deposit_collect_memo: 'text_long_1',

    ACCOUNTS_RECEIVABLE__invoice_natural_id: 'text_ja_255',
    ACCOUNTS_RECEIVABLE__accounts_receivable_memo: 'text_long_without_doublequote',
    ACCOUNTS_RECEIVABLE__receivable_collect_finish_date: 'date_1',
    ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_date: 'date_1',
    ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_amt: 'amt_2',
    ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_memo: 'text_long_without_doublequote',

    TEMP__search_distance: 'limit_max_distance',
    USER_BRANCH__user_branch_name: 'text_ja_255',
    USER_BRANCH__user_branch_fax: 'tel_fax_1',
    USER__user_tel: 'tel_fax_1',

    INFORMATION__display_header: "cst_information_display_header",
    INFORMATION__display_advertisement: "cst_information_display_advertisement",
    INFORMATION__status: "cst_information_status",
    INFORMATION__data_type: "cst_information_data_type",
    INFORMATION__subject: "text_ja_255",
    INFORMATION__body: "text_long_2",
    INFORMATION__ad_url: 'text_long_3',
    INFORMATION__not_login: 'cst_information_not_login',

    NODB__send_upload_notification: 'send_upload_notification',

    // NOTIFICATION
    NOTIFICATION__cc_email: 'mail_1',
    NOTIFICATION__cc_email_subcon: 'mail_1',
    NOTIFICATION__subcon_cc_email: 'mail_1',
    NOTIFICATION__fax: 'tel_fax_3',
    NOTIFICATION__subcon_fax: 'tel_fax_3',

    CUMESSAGE__message: 'text_long_2',
    CUMESSAGE__edit_message: 'text_long_2',

    CU_CUSTOMER_OPTION__customer_login_id: 'id_2',

    REQUEST__contact_memo: 'text_long_2',
    TEMP__contact_memo: 'text_long_2',

    // 申込書
    ESTIMATE__application_form_fax: 'tel_fax_3',
    ESTIMATE__application_form_email: 'mail_1',

    ESTIMATE_DETAIL__estimate_detail_name: 'text_ja_255',
    ESTIMATE_DETAIL__estimate_detail_name_ex: 'text_ja_255',
    ESTIMATE_DETAIL__taxble_estimate_detail_amt: 'amt_1',
    ESTIMATE_DETAIL__non_taxble_estimate_detail_amt: 'amt_1',


    // 自動発注
    CUSTOMER_BRANCH__auto_order_display_flag: 'cst_auto_order_display_flag',
    REQUEST__auto_order_function_flag: 'cst_auto_order_function_flag',
    ESTIMATE__auto_order_execution_flag: 'cst_auto_order_execution_flag',

    CUSTOMER_BRANCH__dandori_work_use_flag: 'cst_dandori_work_use_flag',
    CUSTOMER_BRANCH__dandori_work_place_code: 'dandori_work_place_code',
    CUSTOMER_BRANCH__dandori_work_access_token: 'dandori_work_access_token',

    CUSTOMER_BRANCH__ex_genba_plus_use_flag: 'cst_ex_genba_plus_use_flag',
    CUSTOMER_BRANCH__ex_genba_plus_api_root_url: 'text_long_4',

    // #1674 ANDPAD連携
    CUSTOMER_BRANCH__ex_andpad_use_flag: 'cst_ex_andpad_use_flag',
    CUSTOMER_BRANCH__ex_andpad_access_token_key: 'text_80',
    CUSTOMER_BRANCH__ex_andpad_quote_file_flag: 'cst_ex_andpad_quote_file_flag',

    // #2550 道路使用許可申請書の利用フラグ
    CUSTOMER_BRANCH__road_usage_permission_use_flag:'cst_road_usage_permission_use_flag',
};